import { render, staticRenderFns } from "./add-level-of-studies.vue?vue&type=template&id=60a9af47&scoped=true"
import script from "./add-level-of-studies.vue?vue&type=script&lang=js"
export * from "./add-level-of-studies.vue?vue&type=script&lang=js"
import style0 from "./add-level-of-studies.vue?vue&type=style&index=0&id=60a9af47&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60a9af47",
  null
  
)

export default component.exports